export default __webpack_public_path__ + "static/media/47_Datel_cerny_PELZ_upr.6659ce59.mp3";